import React, { useState, useEffect } from 'react'
import { Form, Button, Image } from 'react-bootstrap'
import '../../index.css'
import { connect } from 'react-redux'
import { useAppContext } from "../../Context";
import { FetchLogin } from '../../fetcher'
import logo from '../../assets/FAEX_Logo.png'
import { useHistory, Redirect } from 'react-router-dom'

const Logout = () => {
    const { userHasAuthenticated } = useAppContext();

    const logout = () => {
        sessionStorage.setItem("usename", "")
        sessionStorage.setItem("loginInformation", null)
        sessionStorage.setItem("isAuthenticated", "false")
        userHasAuthenticated(false)

        return (
            <Redirect to="/authentication" />
        )
    }

    return (
        logout()
    )
}

export default (Logout)